__webpack_require__.p = "/term/_next/";